// Somewhat hacky use of module-scope variables to persist these values between
// the create and remove functions...
let noTasks, noTasksParent;

export function createDummyTask(driverObj, progress) {
  if (progress.completed || progress.currentStep > 1) {
    // Don't faff with fake tasks if the tour has been taken before.
    driverObj.drive(0);
    return;
  }

  const dummy = $(`
    <li class="environment-task--list-item" id="dummy-task-item">
      <div class="environment-task--list-item-body">
        <span class="environment-task--checkbox-wrapper" data-task-state-dropdown="">
          <input type="checkbox" id="dummy-task-checkbox">
        </span>
        <div class="environment-task--name-column">
          <span data-environment-task-edit-trigger="" role="button">Welcome to the EnvOps Dashboard!</span>
            <span class="environment-task--notes" role="button">
              Click the "Take a feature tour" button in the bottom-left for a
              short guide to help you get familiar with the EnvOps dashboard.
              Then, click the checkbox to the left of this task to mark it as
              completed!
            </span>
            <span class="environment-task--notes" role="button">
              This is an example task created as part of the feature tour.
            </span>
        </div>
      </div>
    </li>`);

    $('.environment-tasks--list').prepend(dummy);
    noTasks = document.getElementById('no-tasks-message');
    noTasksParent = noTasks?.parentElement;
    if (noTasks) {
      noTasks.remove();
    }

    document.getElementById('tour-menu').addEventListener(
      'click',
      (evt) => {
        evt.stopImmediatePropagation();
        driverObj.drive(0);
        return false;
      },
      { once: true }
    );

    document.getElementById('dummy-task-checkbox').addEventListener(
      'click',
      removeDummyTask,
      { once: true }
    )
}

export function removeDummyTask() {
  document.getElementById('dummy-task-item')?.remove();
  if (noTasks && noTasksParent) {
    noTasksParent.insertBefore(noTasks, noTasksParent.lastElementChild);
  }
}
